import * as d3 from 'd3'
export default {
  /*
    app_toFixed
  */
  methods: {

     app_toFixed(val, parents, child ) {

      let str = null
      
      if(parents || parents == 0) str = val.toFixed(parents)
      if(parents === null) str = val

      if(child || child == 0) str = val.toFixed(child)
      if(child === null) str = val

      return str 
    },
  

    // Mouse Events ###############################################################
    app_Link(selection, data, col) {
    
      if (!col.filter) return

      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
          d3.select(this).transition().duration(50).style('opacity', .4)
        })
      .on('mouseout', function() {
        d3.select(this).transition().duration(50).style('opacity', 1)
      })
      .on('click', () => {
        this.app_Action(data, col) 
      })
    },

    app_Action(data, col) {

      let dataSource = {}

      Object.keys(this.keys).forEach(d=>{
        dataSource = {...dataSource, [d]: data[this.keys[d]]}
      })
      let filterString_ = this.filters[col.filter] || ''
      let requestText = (col.json && col.json != '') ? col.json : 'request'
      console.log(requestText, dataSource, filterString_)

      // seting request_ from A/G jsonProps
      let request_ = this.getRequestColumnProps(requestText, dataSource, this.ColumnProps)
      if(!request_) return

      if(request_.iFilters.filterString) {
        request_.iFilters.filterString += filterString_ ? ` AND ${filterString_} ` : ''
      } else {
        request_.iFilters.filterString = filterString_||''
      }

      // Combine filterStrings
      request_ = {...request_,
        filters : {
          ...this.FilterValues,
          ...request_.filters,
        },
        iFilters: { 
          filterString : request_.iFilters.filterString||'',
          inputFilter : request_.iFilters.inputFilter,},
      }
      this.$emit('request-action', request_)
    },



    app_UserManual(selection, file, page, sn) {
      let filePath = file
      let CheckHost = this.HOST.endsWith('/') ? this.HOST : this.HOST + '/'
      if(page>0 && !sn) sn = 1; else if(page==0) sn =''

      selection
      .append('rect')
      .attr('class', 'HELP_BG')
      .attr('fill', '#fff').attr('width', this.Canvas.CanvasWidth).attr('height', this.Canvas.CanvasHeight)

      this.appManual = this.svg
      .append('g')
      .attr('transform', `translate(0, 0)`).attr('opacity',0)

      this.loadSvg(
        this.appManual, {x: 0, y: 0, url: filePath + sn + '.svg'}
      ).then(() => {
        d3.selectAll('text').style('font-family', 'roboto')
        this.appManual.transition().duration(200).attr('opacity',1)
        this.appManual
        .append('image')
        .attr('xlink:href', CheckHost + 'UserManual/icon_Close.svg')
        .attr('x', 10).attr('y', 10).attr('width', 25).attr('cursor', 'pointer')
        .on('mouseover', function() {d3.select(this).transition().duration(50).style('opacity', .4)})
        .on('mouseout', function() {d3.select(this).transition().duration(50).style('opacity', 1)})
        .on('click', ()=> {
          this.appManual.transition().duration(300).attr('opacity',0)
          d3.select('#HELP_BG').transition().duration(300).attr('opacity',0)
          setTimeout(() => { 
            this.appManual.remove()
            d3.selectAll('.HELP_BG').remove()
          }, 300)
        })
        if(page>0) this.app_UserManual_page(selection, file, page, sn)
      })
    },

    app_UserManual_page(selection, file, page, sn) {

      if(!sn) sn = 1
      let x_ = 300
      for(let i=1; i<=page; i++) {
        let pageNo = this.appManual
        .append('g')
        .attr('transform', `translate(${x_}, 80)`).attr('cursor', 'pointer')
        .on('mouseover', function() {d3.select(this).transition().duration(50).style('opacity', .4)})
        .on('mouseout', function() {d3.select(this).transition().duration(50).style('opacity', 1)})
        .on('click', ()=> {
          this.appManual.transition().duration(100).attr('opacity',0)
          setTimeout(() => { 
            this.appManual.remove()
            this.app_UserManual(selection, file, page, i)
          }, 100)
        })
        pageNo
        .append('circle')
        .attr('cx', 0).attr('cy', 0).attr('r', 9).attr('fill', sn==i ? '#83D2F5' : '#E0E0DF')
        pageNo
        .append('text')
        .attr('y', 4).attr('fill', '#000').attr('font-size', 12).attr('text-anchor', 'middle').text(i)
        x_ += 30
      }
    },

  }
}
